<template>
  <div
    v-if="showModal"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center p-4"
  >
    <div class="confirm-dialog max-w-[720px] w-full shadow-lg rounded-md bg-zyxel-gray-200">
      <div class="modal-header relative flex items-center">
        <h2 class="text-center flex-grow mt-8 mb-6">
          {{ $t("messages.two_factor_auth.email_auth_title") }}
        </h2>
        <button
          class="absolute top-0 right-0 mt-2 mr-2"
          @click="closeModal"
        >
          <img
            src="@/assets/svg/icon_48px_close.svg"
            alt="close icon"
          >
        </button>
      </div>
      <div class="w-full grow block h-px bg-stone-200" />
      <div class="p-4 sm:mx-20 mt-4 max-w-[560px]">
        <div class="bg-white rounded-lg">
          <div class="flex mb-4 text-left">
            <img
              class="ml-2 sm:ml-6 mt-2 sm:mt-6 h-12 w-12"
              src="@/assets/svg/icon_48px_send.svg"
              alt="send email icon"
            >
            <div class="ml-2 sm:ml-4 mt-2 sm:mt-6">
              <span class="b1 text-zyxel-gray-800 font-bold">{{ $t("messages.common.hint_send_email_to") }}</span><br>
              <span class="b1 text-zyxel-gray-800 font-bold break-all whitespace-normal">{{ user.email }}</span>
            </div>
          </div>
          <p class="b1 block text-left text-zyxel-gray-800 mx-2 sm:mx-6 mb-2 pb-6">
            {{ $t("messages.two_factor_auth.email_auth_enable") }}
          </p>
        </div>
        <div
          v-if="loading"
          class="loader"
        />
        <div v-else>
          <button
            role="button"
            class="b1 text-zyxel-green-700 cursor-pointer"
            @click="handleEmailVerification"
            @keydown.enter="handleEmailVerification"
          >
            {{ $t("messages.common.link_resend_email") }}
          </button>
        </div>
      </div>
      <div class="modal-footer flex justify-end mt-[42px] sm:mt-20">
        <button
          class="ml-3 mb-4 mr-4 button-cancel w-full sm:w-auto min-w-[120px]"
          @click="closeModal"
        >
          {{ $t("messages.button.close") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth';
import { logger } from '@/utils/logger';
export default {
    name: 'SendEmail2FAModal',
    props: {
        showModal: Boolean,
        user: Object,
    },
    data() {
        return {
            loading: false
        };
    },
    methods: {
        closeModal() {
            this.$emit('close-modal');
        },
        async handleEmailVerification() {
            try {
                this.loading = true;
                const auth = useAuthStore();
                await auth.send2FAEmailVerification();
                setTimeout(() => {
                    this.loading = false;
                }, 2000);
            } catch (error) {
                logger.error('Error during email verification:', error);
                this.loading = false;
            }
        }
    }
}
</script>